'use strict';

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('[data-language-trigger]'),
      panel: this.querySelector('[data-language-panel]'),
    };

    if (!this.elements.input || !this.elements.button || !this.elements.panel) {
      return;
    }

    this.elements.button.addEventListener('click', this.togglePanel.bind(this));
    this.elements.button.addEventListener('focusout', this.closePanel.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('[data-language-option]').forEach((item) => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', '');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  submitLanguage(nextValue) {
    const form = this.querySelector('form');

    if (!form || !nextValue || nextValue === this.elements.input.value) {
      this.hidePanel();
      return;
    }

    this.elements.input.value = nextValue;
    form.submit();
  }

  onItemClick(event) {
    event.preventDefault();
    this.submitLanguage(event.currentTarget.dataset.value);
  }

  getAlternateLanguageValue() {
    const currentValue = this.elements.input.value;

    return Array.from(this.querySelectorAll('[data-language-option]')).find(
      (option) => option.dataset.value !== currentValue
    )?.dataset.value;
  }

  togglePanel(event) {
    event.preventDefault();
    event.stopPropagation();

    const options = this.querySelectorAll('[data-language-option]');
    const alternateValue = this.getAlternateLanguageValue();

    if (options.length === 2 && alternateValue) {
      this.submitLanguage(alternateValue);
      return;
    }

    const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.hidePanel();
      return;
    }

    this.elements.button.setAttribute('aria-expanded', 'true');
    this.elements.panel.removeAttribute('hidden');
  }

  closePanel(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';

    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
